import type { IconSymbol } from "../components/icon";

type IconMeta = {
  iconName: IconSymbol;
  textColor: string;
};

export const getIconByExtension = (filename: string): IconMeta => {
  const ext = filename.split(".").pop()?.toLowerCase();
  switch (ext) {
    case "pdf":
      return { iconName: "file-text", textColor: "text-red-500" };
    case "doc":
    case "docx":
      return { iconName: "file-type", textColor: "text-blue-500" };
    case "xls":
    case "xlsx":
    case "csv":
      return { iconName: "sheet", textColor: "text-green-500" };
    case "png":
    case "jpg":
    case "jpeg":
    case "gif":
    case "bmp":
    case "webp":
    case "svg":
      return { iconName: "file-image", textColor: "text-purple-500" };
    case "txt":
      return { iconName: "file-text", textColor: "text-gray-500" };
    default:
      return { iconName: "file-text", textColor: "text-gray-500" };
  }
};
